// extracted by mini-css-extract-plugin
export default {"block":"style_block__MqQKH","fluid":"style_fluid__sGoya"};